module.exports = "/images/vendor/desiigner-svg/svg/logos/48-ore-capri.svg?da17e4702a36bc4fc3b693f8d467ab52";